import { render, staticRenderFns } from "./H5Header.vue?vue&type=template&id=c365c56e&scoped=true&"
import script from "./H5Header.vue?vue&type=script&lang=js&"
export * from "./H5Header.vue?vue&type=script&lang=js&"
import style0 from "./H5Header.vue?vue&type=style&index=0&id=c365c56e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c365c56e",
  null
  
)

export default component.exports